import { Load } from './LeafletMapEngine';

namespace SignalHub.Browser.Maps {
    export function Main() {
        Load();
    }
}

SignalHub.Browser.Maps.Main();